import EditMyProfile from './EditMyProfile'
import { PasswordChange, AddDocuments, ChangeRole } from './components'

export { EditMyProfile, PasswordChange, AddDocuments, ChangeRole }
